import debounce from '../utils/debounce.js'

const scrollBgChange = function () {
  const scrollPosition = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0
  const panels = document.getElementsByClassName('panel')
  const scroll = scrollPosition + (window.screen.height / 1.75)
  const currColor = document.body.getAttribute('data-theme')
  const heroPanel = document.querySelector('.hero.panel')

  Array.prototype.forEach.call(panels, function (panel) {
    if (panel.offsetTop <= scroll && (panel.offsetTop + panel.offsetHeight) > scroll) {
      const newColor = panel.getAttribute('data-color')
      if (currColor !== newColor) {
        document.body.setAttribute('data-theme', newColor)
        heroPanel.setAttribute('data-text-theme', newColor == 'dark' ? 'light' : 'dark')
      }
    }
  })
}

const scrollDebounced = debounce(scrollBgChange)

window.addEventListener('scroll', function () {
  scrollDebounced()
})
